// A partner's home: their concierge clients at a glance, what needs action, and
// what they host next. Partner home redesign, 2026-10-13
// (docs/superpowers/specs/2026-10-13-partner-home-redesign-design.md).
// No money anywhere -- partners never see financial data (2026-09-15 partner spec);
// plan chips and counts only.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { AdminSidebar } from '../components/AdminShell';
import PartnerFilterTiles from '../components/partner/PartnerFilterTiles';
import PartnerAthleteTiles from '../components/partner/PartnerAthleteTiles';
import { PlansCard, ListsCard, EventsCard } from '../components/partner/PartnerSideCards';
import { greeting } from '../components/partner/partnerHome';
import './AdminDashboard.css';
import '../components/AdminShell.css';
import '../components/partner/PartnerHome.css';

export default function PartnerDashboard() {
  const { user, API_URL } = useAuth();
  const [data, setData] = useState(null);
  const [lists, setLists] = useState([]);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    axios.get(`${API_URL}/partner/overview`)
      .then((r) => setData(r.data))
      .catch(() => setError('Could not load your overview. Refresh to try again.'));
    // The lists card is a nicety: a failure here must not take the page down.
    axios.get(`${API_URL}/reports`)
      .then((r) => setLists(Array.isArray(r.data) ? r.data : []))
      .catch(() => setLists([]));
  }, [API_URL]);

  const today = new Date();
  return (
    <div className="adm">
      <div className="adm__shell">
        <AdminSidebar active="overview" />
        <main className="adm__main">
          <header className="ph-header">
            <div>
              <h1 className="ph-header__title">{`${greeting(today)}, ${user?.first_name || ''}`.trim()}</h1>
              <p className="ph-header__date">{today.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' })}</p>
            </div>
            <div className="ph-header__actions">
              <Link to="/lists" className="ph-btn">New list</Link>
              <Link to="/partner/team?add=1" className="ph-btn ph-btn--primary">+ Add athlete</Link>
            </div>
          </header>
          {error && <div role="alert" className="settings-toast settings-toast--error">{error}</div>}
          {data && (
            <>
              <PartnerFilterTiles counts={data.filter_counts} value={filter} onChange={setFilter} />
              <PartnerAthleteTiles rows={data.roster || []} filter={filter} now={today} />
              <div className="ph-strip">
                <PlansCard totals={data.plan_totals} onFilter={setFilter} />
                <ListsCard lists={lists} />
                <EventsCard events={data.upcoming_events || []} />
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
}
